import { useContext } from "react";
import { AskConfirmation, ConfirmDialogCtx } from "./ConfirmDialogCtx.ts";

export function useConfirm(): AskConfirmation {
  const askConfirmation = useContext(ConfirmDialogCtx);
  if (!askConfirmation)
    throw new Error("useConfirm must be used inside ConfirmDialogProvider");
  return askConfirmation;
}
